var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345 5106 c-84 -21 -147 -57 -210 -121 -65 -65 -105 -137 -124 -223 -16 -76 -16 -4328 0 -4404 37 -172 175 -310 347 -347 74 -16 3038 -16 3114 0 171 36 310 175 347 347 7 34 11 193 11 454 l0 400 -111 -103 c-61 -57 -127 -116 -147 -130 -48 -34 -889 -426 -965 -450 -73 -23 -184 -25 -258 -3 -236 69 -375 328 -300 561 10 32 99 231 198 443 99 212 195 417 213 455 31 66 67 105 701 740 l669 670 0 657 c0 452 -4 674 -11 710 -37 172 -176 311 -347 347 -80 17 -3059 14 -3127 -3z m2765 -976 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -39 -20 -56 -20 -1191 -20 l-1151 0 -40 22 c-101 57 -102 194 -2 254 l39 24 1153 0 c1136 0 1153 0 1192 -20z m-480 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -38 -20 -57 -20 -951 -20 l-911 0 -40 22 c-101 57 -102 194 -2 254 l39 24 913 0 c895 0 914 0 952 -20z m-480 -800 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -38 -19 -57 -20 -711 -20 l-671 0 -40 22 c-101 57 -102 194 -2 254 l39 24 673 0 c655 0 674 -1 712 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4483 3576 c-68 -22 -101 -48 -238 -186 l-130 -130 338 -337 337 -338 135 135 c165 164 190 207 190 320 0 117 -23 154 -212 342 -175 173 -213 198 -317 204 -35 2 -79 -2 -103 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3328 2473 l-578 -578 -108 -230 c-262 -555 -312 -670 -312 -710 0 -49 29 -98 72 -126 65 -40 93 -31 570 192 l438 204 582 577 583 576 -335 336 -335 336 -577 -577z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.7c6ea7de62bc493ea2d2dfa56c1e0d02.svg";
export { ForwardRef as ReactComponent };